exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#clients_page .fa-trash-o {\n  font-size: 1.4rem;\n  padding: 0.1rem;\n}\n#clients_page .sources img {\n  max-height: 2.6rem;\n}", ""]);

// exports
